import apiHelperFinance from '@/services/helperFinance'
import apiHelper from '@/services/helper'

const getListPayment = async (param) => {
    try {
        let url = '/admin/payment/get-all'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getListPaymentAllDeleted = async (param) => {
    try {
        let url = '/admin/payment/get-all-deleted'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const createPayment = async (param) => {
    try {
        let url = '/admin/payment/create'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getPaymentDetail = async (param) => {
    try {
        let url = '/admin/payment/get-detail'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updatePayment = async (param) => {
    try {
        let url = '/admin/payment/update'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const deletePayment = async (param) => {
    try {
        let url = '/admin/payment/delete'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getOrderListWithShopID = async (param) => {
    try {
        let url = '/admin/payment/get-order-list'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateRunningNumber = async (param) => {
    try {
        let url = '/admin/payment/update-detail'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const printOrder = async (param) => {
    try {
        let url = '/order/save/print'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const confirmPayment = async (param) => {
    try {
        let url = '/admin/payment/confirm'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getPaymentHistory = async (param) => {
    try {
        let url = '/admin/subscription/payments/histories'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const generateQrPayment = async (param) => {
    try {
        let url = '/admin/subscription/payments/qrcode/generate'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

export default {
    getListPayment,
    createPayment,
    getPaymentDetail,
    updatePayment,
    deletePayment,
    getOrderListWithShopID,
    getListPaymentAllDeleted,
    updateRunningNumber,
    printOrder,
    confirmPayment,
    getPaymentHistory,
    generateQrPayment
}
